import React from 'react';
import PropTypes from 'prop-types';
import { SkeletonContainer, InfoSkeleton, LineContent } from './styles';

const MiniCardSkeleton = ({ device }) => {
  return (
    <SkeletonContainer device={device}>
      <LineContent
        width={device !== 'tablet' ? '84px' : '165px'}
        height='100%'
        borderRadius={device !== 'mobile' ? '0px' : '8px'}
      />
      <InfoSkeleton device={device}>
        <LineContent width={device !== 'tablet' ? '83px' : '143px'} height={device !== 'tablet' ? '16px' : '20px'} />
        <LineContent width={device !== 'tablet' ? '175px' : '455px'} height={device !== 'tablet' ? '16px' : '20px'} />
        <LineContent width={device !== 'tablet' ? '120px' : '347px'} height={device !== 'tablet' ? '16px' : '20px'} />
      </InfoSkeleton>
    </SkeletonContainer>
  );
};

MiniCardSkeleton.propTypes = {
  device: PropTypes.string.isRequired
};

export default MiniCardSkeleton;
